{
  "login": {
    "fractalIdPlaceholder": "Fractal ID o Email",
    "passwordPlaceholder": "Contraseña",
    "createFractalIdLink": "Crear Fractal Id",
    "forgotPasswordLink": "Olvido la contraseña?",
    "loginButton": "Entrar",
    "loginError": "Correo eletrónico/Fractal Id o contrasenã inválidos"
  },
  "register": {
    "registerTitle": "Registrate!",
    "namePlaceholder": "Nombre completo",
    "emailPlaceholder": "Email",
    "passwordPlaceholder": "Contrasenã",
    "confirmPasswordPlaceholder": "Repite la contraseña",
    "registerButton": "Registrarse",
    "loginLink": "Inicie sésion con Fractal ID",
    "registerError": "No fue posible registrarse.",
    "emailInUse": "Correo eletrónico já está en uso!"
  },
  "resetPassword": {
    "resetPasswordTitle": "Recuperar acceso",
    "fractalIdPlaceholder": "Introduce tu correo electrónico",
    "passwordPlaceholder": "Contrasenã",
    "sendButton": "Enviar",
    "backLink": "Volver",
    "confirmPasswordPlaceholder": "Confirmar contraseña",
    "changeButton": "Cambiar contraseña",
    "secretQuestion": "Pregunta secreta",
    "passwordResetEmailSentSuccessfully": "El link para recuperarsu contraseña será enviado por correo eletrónico.",
    "passwordResetEmailSentError": "No se pudo enviar un correo electrónico para restablecer la contraseña",
    "noSecretQuestion": "Introduce un correo electrónico válido",
    "resetPasswordSuccess": "Contraseña se ha restablecido",
    "resetPasswordError": "No se pudo restablecer la contraseña",
    "alreadyUsedLink": "Este enlace ya ha sido utilizado. Solicite un nuevo enlace para restablecer su contraseña."
  },
  "editUserForm": {
    "nameLabel": "Nombre",
    "emailLabel": "Email",
    "birthdayLabel": "Fecha de nacimiento",
    "phoneLabel": "Teléfono",
    "documentLabel": "Documento",
    "genreLabel": "Género",
    "maleGenreLabel": "Masculino",
    "femaleGenreLabel": "Femenino",
    "zipcodeLabel": "Codigo Postal",
    "streetLabel": "Calle",
    "numberLabel": "Número",
    "complementLabel": "Complemento",
    "neighborhoodLabel": "Vecindario",
    "personalInformation": "Información personal",
    "cityLabel": "Ciudad",
    "stateLabel": "Provincia",
    "phoneMask": "+595 ##########",
    "selectCountry": "Selecciona tu pais",
    "editDataSuccess": "Datos modificados con éxito",
    "editDataFailure": "Error al cambiar los datos",
    "updateProfileImage": "Actualizar foto de perfil",
    "removeProfileImage": "Eliminar foto de perfil",
    "uploadImageError": "Error al cargar la imagen.",
    "uploadImageSizeError": "¡Inserta una imagen de hasta 200 KB!",
    "removedImage": "Foto de perfil eliminada",
    "updatedImage": "La foto de perfil se modificó correctamente.",
    "updateImageError": "Error al actualizar la foto de perfil"
  },
  "securityCard": {
    "security": "Seguridad",
    "securityWarning": "Mantenga sus datos actualizados para proteger su Fractal ID",
    "changePassword": "Cambiar contraseña",
    "changeEmail": "Cambiar Email",
    "logoutButton": "Hacer Logout",
    "backButton": "VOLVER",
    "editEmailSuccess": "Correo electrónico cambiado correctamente",
    "editEmailFailure": "Error al cambiar el correo electrónico",
    "editPasswordSuccess": "Contraseña alterada con éxito",
    "editPasswordFailure": "Error al cambiar la contraseña"
  },
  "profilePage": {
    "saveButton": "Guardar",
    "cancelButton": "Cancelar",
    "warning": "Aún tienes cambios pendientes. ¿De verdad quieres irte?"
  },
  "changeEmailForm":{
    "emailFormTitle": "Alterar E-mail",
    "emailPlaceholder": "E-mail...",
    "changeButton": "Alterar"
  },
  "changePasswordForm": {
    "passwordFormTitle": "Cambiar contraseña",
    "newPasswordPlaceholder": "Nueva contraseña",
    "confirmPasswordPlaceholder": "Confirmar nueva contraseña",
    "changeButton": "Cambiar"
  },
  "recoverPasswordForm": {
    "passwordFormTitle": "Restablecimiento de contraseña",
    "newPasswordPlaceholder": "Nueva contraseña",
    "confirmPasswordPlaceholder": "Confirmar nueva contraseña",
    "changeButton": "Cambiar"
  },
  "changeTemporaryPassword": {
    "passwordFormTitle": "Restablecimiento de contraseña temporal",
    "newPasswordPlaceholder": "Nueva contraseña",
    "confirmPasswordPlaceholder": "Confirmar nueva contraseña",
    "changeButton": "Cambiar"
  }
}
